import Http from "./http";

export const getProductFeaturesAPI = (data, options) => {
  return Http.post("admin/product/getProductFeatures", data, options);
};